import React from 'react';
import {type MessageDescriptor} from 'react-intl';
import {useAutoMapper} from '@igp/shared/auto-mapper';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {PayoutReportServiceTypes} from '../constants';
import {payoutReportMappingKeys} from '../mapper';
import type {PayoutReportColumns, PayoutReportViewModelKeys} from '../types';

import {localized} from './DataGrid';

export type PayoutReportDownloadCsvButtonProps = Pick<
    UseDownloadProps<PayoutReportViewModelKeys>,
    'filename' | 'filter' | 'total' | 'mode'
> & {
    columns: PayoutReportColumns[];
};

function usePayoutReportDownload({columns, ...props}: PayoutReportDownloadCsvButtonProps): UseDownloadResult {
    const mapper = useAutoMapper();
    const keys = columns.map(c =>
        mapper.map<PayoutReportColumns, PayoutReportViewModelKeys>(
            c,
            payoutReportMappingKeys.columns,
            payoutReportMappingKeys.viewModelsKeys
        )
    );
    const {handleDownload, isProgress} = useDownload<PayoutReportViewModelKeys>({
        ...props,
        strategySymbol:
            props.mode === 'client' ? PayoutReportServiceTypes.downloadClientStrategy : PayoutReportServiceTypes.downloadServerStrategy,
        headersLocalization: localized as Record<PayoutReportViewModelKeys, MessageDescriptor>,
        keys,
    });

    return {handleDownload, isProgress};
}

export function PayoutReportDownloadCsvButton(props: PayoutReportDownloadCsvButtonProps) {
    const {handleDownload, isProgress} = usePayoutReportDownload(props);

    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || props.total === 0} />;
}
